import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import arrowIcon from '../../assets/icons/icon-arrow-down.svg';
import { MOBILE_BREAKPOINT_IN_PX } from '../../constants';

const CollapsibleContainerWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: white;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 18px;
  letter-spacing: -0.5px;
  line-height: 22px;

  @media screen and (min-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    display: none;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    display: block;
    border-top: 1px solid #ccc;
  }

  .Collapsible {
  }

  .Collapsible__trigger {
    display: block;
    font-weight: 400;
    position: relative;
    padding: 25px 0 0px 20px;
    color: black;
    cursor: pointer;

    &:after {
      width: 29px;
      height: 24px;
      background-image: url(${arrowIcon});
      background-size: 12px 14px;
      background-repeat: no-repeat;
      background-position: center left;
      content: '';
      display: inline-block;
      height: 0.55em;
      width: 0.55em;
      position: absolute;
      right: 20px;
      top: 27px;
      transition: transform 400ms;

      @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
        width: 20px;
        background-size: 18px 18px;
      }
    }

    &.is-open {
      &:after {
        transform: rotateZ(-180deg);
      }  
  }

  .Collapsible__contentInner {
  }
`;

const CollapsibleContainer = ({ children }) => (
  <CollapsibleContainerWrapper>{children}</CollapsibleContainerWrapper>
);

CollapsibleContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CollapsibleContainer;
